export enum StructureCodeEnum {
  K0 = 'k0',
  K1 = 'k1',
  K2 = 'k2',
  K3 = 'k3',
  K4 = 'k4',
  G1 = 'g1',
  G2 = 'g2',
  G3 = 'g3',
  G4 = 'g4',
  G5 = 'g5',
  G6 = 'g6',
  G7 = 'g7',
  G8 = 'g8',
  G9 = 'g9',
  G10 = 'g10',
  G11 = 'g11',
  G12 = 'g12',
  G13 = 'g13',
}
